import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core'
import { useState } from 'react'
import { FormLabel } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { createFeedback } from 'src/axios/api'
import { setShowFeedback } from 'src/redux/reducer/commomReducer.js/commonReducer'
import './chat.css'

const FeedbackForm = ({ userId, consultantId, logout }) => {
  const emptyStars = [1, 2, 3, 4, 5]
  const [accessibility, setAccessibility] = useState('')
  const [distressed, setDistressed] = useState('')
  const [satisfaction, setSatisfaction] = useState(0)
  const [message, setMessage] = useState('')
  const dispatch = useDispatch()
  const handleSubmit = async (e) => {
    try {
      e.preventDefault()

      const data = {
        accessibility,
        distressed,
        satisfaction,
        message,
        userId,
        consultantId,
      }
      if (consultantId !== 'anonomyous') await createFeedback(data)
      dispatch(setShowFeedback(false))
      localStorage.clear()
      logout()
    } catch (error) {
      console.log(error.message)
    }
  }

  return (
    <div style={{ height: '335px', overflow: 'auto' }}>
      <form onSubmit={handleSubmit} className="container px-3 py-3">
        <h4 className="pb-2 border-bottom mb-2">Feedback</h4>
        <div className="ps-3 pb-2">
          <FormLabel id="demo-radio-buttons-group-label">
            iCALL’s ReYou was technically sound and easy to access.*
          </FormLabel>
          <RadioGroup aria-labelledby="demo-radio-buttons-group-label" name="radio-buttons-group">
            <FormControlLabel
              value="Strongly Disagree"
              control={<Radio size="small" />}
              label="Strongly Disagree"
              onClick={() => setAccessibility('Strongly Disagree')}
            />
            <FormControlLabel
              value="Disagree"
              control={<Radio size="small" />}
              label="Disagree"
              onClick={() => setAccessibility('Disagree')}
            />
            <FormControlLabel
              value="Neutral"
              control={<Radio size="small" />}
              label="Neutral"
              onClick={() => setAccessibility('Neutral')}
            />
            <FormControlLabel
              value="Agree"
              control={<Radio size="small" />}
              label="Agree"
              onClick={() => setAccessibility('Agree')}
            />
            <FormControlLabel
              value="Strongly Agree"
              control={<Radio size="small" />}
              label="Strongly Agree"
              onClick={() => setAccessibility('Strongly Agree')}
            />
          </RadioGroup>
        </div>
        <div className="ps-3 pb-2">
          <FormLabel id="demo-radio-buttons-group-label">
            I feel less distressed than I was before the counseling session.*
          </FormLabel>
          <RadioGroup aria-labelledby="demo-radio-buttons-group-label" name="radio-buttons-group">
            <FormControlLabel
              value="Strongly Disagree"
              control={<Radio size="small" />}
              label="Strongly Disagree"
              onClick={() => setDistressed('Strongly Disagree')}
            />
            <FormControlLabel
              value="Disagree"
              control={<Radio size="small" />}
              label="Disagree"
              onClick={() => setDistressed('Disagree')}
            />
            <FormControlLabel
              value="Neutral"
              control={<Radio size="small" />}
              label="Neutral"
              onClick={() => setDistressed('Neutral')}
            />
            <FormControlLabel
              value="Agree"
              control={<Radio size="small" />}
              label="Agree"
              onClick={() => setDistressed('Agree')}
            />
            <FormControlLabel
              value="Strongly Agree"
              control={<Radio size="small" />}
              label="Strongly Agree"
              onClick={() => setDistressed('Strongly Agree')}
            />
          </RadioGroup>
        </div>
        <small>
          On a scale of 1 - 5 (1 being the lowest and 5 the highest), suggest your overall
          satisfaction with the iCALL’s ReYou:*{' '}
        </small>
        <div className="ps-3 pb-2">
          {emptyStars.map((e, i) => {
            return (
              <span
                className={`${
                  e <= satisfaction ? 'star-icon-checked' : 'star-icon-unchecked'
                } mx-2`}
                onClick={() => setSatisfaction(e)}
                key={e}
              >
                &#9733;
              </span>
            )
          })}
        </div>
        Care to share about us?
        <textarea
          className="form-control my-2"
          id="exampleFormControlTextarea1"
          rows="3"
          onChange={(e) => setMessage(e.target.value)}
        ></textarea>
        <div className="d-flex justify-content-between">
          <button type="submit" className="submit-btn rounded-1">
            Submit
          </button>
        </div>
      </form>
    </div>
  )
}

export default FeedbackForm
